export const PROGRAM_BENEFITS_7_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_title_color: "#222222",
    meta_sub_title: "",
    meta_sub_title_color: "#505050",
    meta_priority: "1",
  },

  PROGRAM_BENEFITS_7_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Your MCA {Advantage}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title (wrap a phrase in { } to highlight it)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_start_color",
      label: "Title Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #222222)",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "title_end_color",
      label: "Highlighted Text Color",
      value: "#E15518",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter highlighted text color (e.g., #E15518)",
      required: false,
      defaultValue: "#E15518",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "image",
      label: "Featured Image (Desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop featured image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Featured Image (Mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile featured image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Featured Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter featured image alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Program Benefits Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Benefits",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon",
    },
    {
      header: "Icon Alt Text",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Icon Alt Text",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #222222)",
      defaultValue: "#222222",
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
    },
    {
      header: "Description Color",
      fieldName: "meta_sub_title_color",
      value: "#505050",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #505050)",
      defaultValue: "#505050",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: false,
    },
  ],
};
